import ActivityDetails from '@activities/components/details/activity-details/activity-details.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-activity-details',
  components: {
    'bpc-activity-details': ActivityDetails,
  },
})
export default class ProfileActivityDetails extends Vue {
  @Prop({ type: String }) readonly alias: string;
  @Prop({ type: [String, Number] }) readonly postId: string | number;
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
